import { showMore } from 'owa-locstrings/lib/strings/showmore.locstring.json';
import { showLess } from 'owa-locstrings/lib/strings/showless.locstring.json';
import { allContextMenuItemText } from 'owa-locstrings/lib/strings/allcontextmenuitemtext.locstring.json';
import { linksText } from '../index.locstring.json';
import loc from 'owa-localize';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { FileExtensionType, getFileExtensionData } from 'owa-files-filter-file-extensions-filter';

import {
    selectExtensionFilterAction,
    clearExtensionFilterAction,
    expandFileExtensionsFilterMenu,
    collapseFileExtensionsFilterMenu,
    clearExtensionGroupFilterAction,
    selectLinksContextMenuItemAction,
    clearLinksContextMenuItemAction,
} from '../actions/publicActions';

export type IsFileExtensionSelectedFuncType = (value: FileExtensionType) => boolean;
export type BoolSelectorFuncType = () => boolean;
type ModifyFileExtensionStateFuncType = (extensionType?: FileExtensionType) => void;

const styles = require('./FileExtensionFilterContextMenu.scss');

export function getFileExtensionContextMenuItems(
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionsExpanded: BoolSelectorFuncType,
    allowImagesExtensionType: boolean,
    selectExtensionFunc?: ModifyFileExtensionStateFuncType
): IContextualMenuItem[] {
    const contextMenuItems = [];

    if (allowImagesExtensionType) {
        contextMenuItems.push(
            getExtensionContextMenuItem(FileExtensionType.Images, isExtensionSelected)
        );
    }

    const defaultExtensionOptions = [
        // order matters
        FileExtensionType.Documents,
        FileExtensionType.PowerPoint,
        FileExtensionType.Spreadsheets,
        FileExtensionType.PDFs,
    ].map(e => getExtensionContextMenuItem(e, isExtensionSelected, selectExtensionFunc));
    contextMenuItems.push(...defaultExtensionOptions);

    if (isExtensionsExpanded()) {
        const expandedExtensionOptions = [
            FileExtensionType.Text,
            FileExtensionType.Email,
            FileExtensionType.Visio,
            FileExtensionType.Audio,
            FileExtensionType.Xml,
        ].map(e => getExtensionContextMenuItem(e, isExtensionSelected, selectExtensionFunc));
        contextMenuItems.push(...expandedExtensionOptions);
    }

    const moreContextmenuItem = getMoreContextMenuItem(isExtensionsExpanded);
    contextMenuItems.push(moreContextmenuItem);
    return contextMenuItems;
}

export function getExtensionContextMenuItem(
    extensionFilter: FileExtensionType,
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    selectFileExtensionFunc?: ModifyFileExtensionStateFuncType,
    clearFileExtensionFunc?: ModifyFileExtensionStateFuncType,
    hideIcon?: boolean
): IContextualMenuItem {
    const extensionGroupData = getFileExtensionData(extensionFilter);
    const isChecked = isExtensionSelected(extensionFilter);

    selectFileExtensionFunc = selectFileExtensionFunc || selectExtensionFilterAction;
    clearFileExtensionFunc = clearFileExtensionFunc || clearExtensionFilterAction;

    return {
        key: extensionFilter.toString(),
        name: extensionGroupData.text,
        iconProps: {
            styles: {
                root: extensionGroupData.icon && !hideIcon ? extensionGroupData.icon.small : null,
            },
        },
        canCheck: true,
        checked: isChecked,
        onClick: event => {
            event.preventDefault();
            if (isChecked) {
                clearFileExtensionFunc(extensionFilter);
            } else {
                selectFileExtensionFunc(extensionFilter);
                if (
                    extensionFilter === FileExtensionType.Images ||
                    extensionFilter === FileExtensionType.Files
                ) {
                    clearLinksContextMenuItemAction();
                }
            }
        },
    };
}

export function getAllContextMenuItem(
    isNoExtensionSelected: BoolSelectorFuncType
): IContextualMenuItem {
    const isChecked = isNoExtensionSelected();

    return {
        key: loc(allContextMenuItemText),
        name: loc(allContextMenuItemText),
        iconProps: {
            styles: {
                root: null,
            },
        },
        canCheck: true,
        checked: isChecked,
        onClick: event => {
            event.preventDefault();
            if (!isChecked) {
                clearExtensionGroupFilterAction();
                clearLinksContextMenuItemAction();
            }
        },
    };
}

export function getLinksOnlyContextMenuItem(
    isLinksFilterSelected: BoolSelectorFuncType
): IContextualMenuItem {
    const isChecked = isLinksFilterSelected();

    return {
        key: 'links',
        name: loc(linksText),
        iconProps: {
            styles: {
                root: null,
            },
        },
        canCheck: true,
        checked: isChecked,
        onClick: event => {
            event.preventDefault();
            if (isChecked) {
                clearLinksContextMenuItemAction();
            } else {
                selectLinksContextMenuItemAction();
                clearExtensionFilterAction(FileExtensionType.Images);
            }
        },
    };
}

function getMoreContextMenuItem(isExtensionsExpanded: BoolSelectorFuncType): IContextualMenuItem {
    const isExpanded = isExtensionsExpanded();
    return {
        key: isExpanded ? loc(showLess) : loc(showMore),
        name: isExpanded ? loc(showLess) : loc(showMore),
        itemProps: {
            styles: { root: styles.moreRoot, label: styles.moreLabel, icon: styles.noIcon },
        },
        onClick: event => {
            event.preventDefault();

            if (isExpanded) {
                collapseFileExtensionsFilterMenu();
            } else {
                expandFileExtensionsFilterMenu();
            }
        },
    };
}
